import { Fragment, FunctionComponent, h } from 'preact'
import { RoutableProps } from 'preact-router'

export const Home: FunctionComponent<RoutableProps> = () => {
  return (
    <Fragment>
      <section className="section">
        <div className="section-title">役員の引き継ぎ会議</div>
        <div className="section-title">Executive handover meeting</div>
        <div className="date">2021/1/19</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants:7</div>
        <div>
          Description: The succession of officers was discussed. We also discussed whether or not to create a new web
          page.
        </div>
      </section>
      <section className="section">
        <div className="section-title">役員の選出会議</div>
        <div className="section-title">Meeting to elect officers</div>
        <div className="date">2021/12/22</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants:7</div>
        <div>Description: 来年度の役員選出および承認を行いました．</div>
      </section>
      <section className="section">
        <div className="section-title">第3回役員会</div>
        <div className="section-title">3st Board Meeting</div>
        <div className="date">2021/12/01</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants:5</div>
        <div>
          Description:
          今年度の新たな役員(会計)を迎えました．現役員との顔合わせは初めてだったので，自己紹介を行い親睦を深めました．
        </div>
      </section>
      <section className="section">
        <div className="section-title">第2回役員会(規約改正の会議)</div>
        <div className="section-title">2st Board Meeting</div>
        <div className="date">2021/11/10 - 2021/11/16</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants:4</div>
        <div>Description: We discussed the revision of the rule, and created a new rule.</div>
        <div className="linkbox">
          <p>↓改正後の規約はこちら↓</p>
          <a href="https://hiroshima-ssb.netlify.app/assets/rule/IEEE_hirosshima_branch.pdf">ここをクリック!</a>
        </div>
      </section>
      <section className="section">
        <div className="section-title">第1回役員会</div>
        <div className="section-title">1st Board Meeting</div>
        <div className="date">2021/5/25</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants:4</div>
        <div>
          Description: We discussed the activities of the SBLTW (Student Branch Leadership Training Workshop) and
          changes to the bylaws to elect officers for the vacant positions.
        </div>
      </section>
      <section className="section">
        <div className="section-title">役員の選出会議</div>
        <div className="section-title">Meeting to elect officers</div>
        <div className="date">2021/1/29</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants:7</div>
        <div>Description: We decided on the officers.</div>
      </section>
      <section className="section">
        <div className="section-title">ホームページ管理の引き継ぎ</div>
        <div className="section-title">Homepage management</div>
        <div className="date">2021/1/6</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants:4</div>
        <div>Description: Teaching of homepage management.</div>
      </section>
      <section className="section">
        <div className="section-title">懇親会</div>
        <div className="section-title">Get-together</div>
        <div className="date">2020/12/16</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants: 5</div>
        <div>Description: Get-together with 2021 officer candidates.</div>
      </section>
      <section className="section">
        <div className="section-title">第22回IEEE広島支部学生シンポジウム後援</div>
        <div className="section-title">Support 22nd HISS</div>
        <div className="date">2020/11/28 - 2020/11/29</div>
      </section>
      <section className="section">
        <div className="section-title">第3回役員会</div>
        <div className="section-title">3rd Board Meeting</div>
        <div className="date">2020/11/17</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants: 4</div>
        <div>Description: We planned a handover meeting.</div>
      </section>
      <section className="section">
        <div className="section-title">SYWL Workshop 2020</div>
        <div className="date">2020/10/17</div>
        <div className="details">
          <div>
            SB members participated as committee members of SYWL (Student Branch, Young Professionals, Women in
            Engineering, Life Member Affinity Group) Workshop 2020 for the purpose of activating the Student Branch.
          </div>
        </div>
        <div className="details">
          <div>3 preparation meetings for SYWL 2020 were held as follows:</div>
          <div>1. The first preparation meeting</div>
          <div>Date: Aug. 31, 2020</div>
          <div>Location: Online (Zoom)</div>
          <div>Number of participants: 22</div>
          <div>2. The 2nd preparation meeting</div>
          <div>Date: Sept. 14, 2020</div>
          <div>Location: Online (Zoom)</div>
          <div>Number of participants: 20</div>
          <div>3. The 3rd preparation meeting</div>
          <div>Date: Oct. 12, 2020</div>
          <div>Location: Online (Zoom)</div>
          <div>Number of participants: 24</div>
        </div>
        <div className="details">
          <div>SYWL workshop 2020</div>
          <div>Date: Oct. 17, 2020</div>
          <div>Location: Hiroshima (onsite) and online(zoom)</div>
          <div>Attendance: 45 (onsite 25, online 20)</div>
        </div>
        <div>
          <img className="activity" src="/assets/activity_images/2020/SYWL.jpg" />
        </div>
      </section>
      <section className="section">
        <div className="section-title">第2回役員会</div>
        <div className="section-title">2nd Board Meeting</div>
        <div className="date">2020/10/13</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants: 4</div>
        <div>Description: We discussed our rules, 2021 plan, management of things, and so on.</div>
      </section>
      <section className="section">
        <div className="section-title">第1回役員会</div>
        <div className="section-title">1st Board Meeting</div>
        <div className="date">2020/9/18</div>
        <div>Location: Online(Google Meet)</div>
        <div>Number of participants: 5</div>
        <div>
          Description: We discussed election of officers, homepage management, mail account management, and so on.
        </div>
      </section>
      <section className="section">
        <div className="section-title">第21回IEEE広島支部学生シンポジウム後援</div>
        <div className="date">2019/11/30 - 2019/12/1</div>
        <div>岡山県立大学で開催された第21回IEEE広島支部学生シンポジウムに後援しました。</div>
      </section>
      <section className="section">
        <div className="section-title">第21回IEEE広島支部学生シンポジウム参加</div>
        <div className="date">2019/11/30 - 2019/12/1</div>
        <div>
          岡山県立大学で開催された第21回IEEE広島支部学生シンポジウムに本ブランチの学生が参加し、ポスター発表による議論を行いました。
        </div>
      </section>
      <section className="section">
        <div className="section-title">第20回IEEE広島支部学生シンポジウム後援</div>
        <div className="date">2018/11/17 - 2018/11/18</div>
        <div>鳥取大学で開催された第20回IEEE広島支部学生シンポジウムに後援しました。</div>
      </section>
      <section className="section">
        <div className="section-title">第20回IEEE広島支部学生シンポジウム参加</div>
        <div className="date">2018/11/17 - 2018/11/18</div>
        <div>
          鳥取大学で開催された第20回IEEE広島支部学生シンポジウムに本ブランチの学生が参加し、ポスター発表による議論を行いました。
        </div>
      </section>
      <section className="section">
        <div className="section-title">キックオフミーティング＠伯耆大山</div>
        <div className="date">2018/10/7 - 2018/10/8</div>
        <div>
          IEEE広島支部学生ブランチの立ち上げに伴い、メンバーの顔合わせと役職の割当てや今後の方針などを話し合いました。
          二日目は親睦を深めるために、中国地方唯一の日本百名山である伯耆大山(1729m)の登山を行い、無事全員が登頂に成功しました。
        </div>
      </section>
      <section className="section">
        <div className="section-title">IEEE広島支部学生ブランチ設立</div>
        <div className="date">2018/8/24</div>
        <div>
          IEEE広島支部学生ブランチ設立が2018年8月24日に設立されました。
          カウンセラーの先生方と初期メンバー10人で広島支部を盛り上げられるように活動してまいります。
        </div>
      </section>
    </Fragment>
  )
}
